var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page-contact"},[_c('div',{staticClass:"pagewrap"},[_c('div',{staticClass:"contact"},[_c('pre',[_vm._v(_vm._s(_vm.jsonResume))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }